export enum TicketAirline {
  Volaris = 'Volaris',
  Aeromexico = 'Aeromexico',
  VivaAerobus = 'Viva Aerobus',
  Calafia = 'Calafia',
}
